<template>
  <section class="flex flex-col items-center justify-center px-10 pb-10">
    <div class="h-52 w-52">
      <img :src="swappingBox" class="h-full w-full object-cover" />
    </div>
    <p class="text-sm lg:text-base font-bold -mt-5 mb-4">
      Swapping in Progress!
    </p>
    <p
      style="word-break: normal"
      class="text-xs font-light w-full lg:w-3/4 mx-auto text-center leading-loose"
    >
      We are working on your request. This usually takes at most about 2 hours.
      Feel free to leave this page as you will be notified about the progress
      via email.
    </p>
  </section>
</template>

<script>
import swappingBox from '@/assets/v2/images/swapping-box.gif'
import getSwappedPairDetailsById from '@/mixins/bridge.js'
export default {
  mixins: [getSwappedPairDetailsById],
  name: 'SwappingScreen',
  data () {
    return {
      swappingBox,
      count: 0,
      intervalId: '',
      maxWaitTime: 900
    }
  },
  computed: {
    initiatedSwapDetails () {
      return this.$store.state.bridge.initiatedSwapDetails
    }
  },
  methods: {
    getSwappedPairDetailsByIdHandler () {
      const swappedPairId = this.initiatedSwapDetails.swap.id
      this.getSwappedPairDetailsById(swappedPairId)
      this.intervalId = setInterval(() => {
        this.count += 3
        this.getSwappedPairDetailsById(swappedPairId)
      }, 3000)
    },
    nextStep () {
      this.$emit('next')
    }
  },
  watch: {
    '$store.state.bridge.swappedPairDetailsById.swap.status': function (
      newValue
    ) {
      if (newValue === 'completed') {
        clearInterval(this.intervalId)
        this.nextStep()
      }
    },
    count (newValue) {
      if (newValue === this.maxWaitTime) {
        clearInterval(this.intervalId)
      }
    }
  },
  mounted () {
    this.getSwappedPairDetailsByIdHandler()
  },
  destroyed () {
    clearInterval(this.intervalId)
  }
}
</script>
